module.exports = __webpack_public_path__ + "static/media/estateCaixa.c8eb16b0.png";